import { Component, ViewChild, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { GeneralInfoComponent } from '../../components';
import { MatButtonModule } from '@angular/material/button';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UpdateUserModel, UserProfile } from '@core/models';
import { TranslateModule } from '@ngx-translate/core';
import { UserStore } from '@root/app/store/user.store';

@Component({
  selector: 'xemex-user-details-page',
  imports: [
    RouterModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    GeneralInfoComponent,
    TranslateModule,
  ],
  templateUrl: './user-details-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './user-details-page.component.scss',
})
export class UserDetailsPageComponent {
  readonly userStore = inject(UserStore);

  @ViewChild(GeneralInfoComponent)
  generalInfoComponent!: GeneralInfoComponent;

  userId!: string;
  isLoading = false;
  userProfile: UserProfile | undefined;
  userAvatar: any;
  isEdited = false;
  oid = '';

  constructor(readonly route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      if (params['oid']) {
        this.oid = params['oid'];
        this.userStore.getUserMethod(this.oid);
        this.userStore.getUserAvatarMethod(this.oid);
      }
    });

    effect(() => {
      this.userProfile = this.userStore.user();
      this.userAvatar = this.userStore.userAvatar();
      this.isLoading = this.userStore.isLoading();
    });
  }

  onUploadAvatar(imageBlob: BlobPart) {
    this.userStore.updateUserAvatarMethod({
      avatar: imageBlob,
      oid: this.oid,
    });
  }

  onSaveChanges() {
    this.isShowSaveChangesBtn();
    const userUpdated = this.generalInfoComponent.formValue as UpdateUserModel;
    const user: UpdateUserModel = {
      ...userUpdated,
    };

    if (!user.phone?.length) {
      delete user.phone;
    }

    this.userStore.updateUserMethod({ user, oid: this.oid });
  }

  isShowSaveChangesBtn(): boolean {
    const currentValue = this.generalInfoComponent.formValue;
    const initialValue = this.userProfile;
    return (
      initialValue?.firstName !== currentValue.firstName ||
      initialValue?.lastName !== currentValue.lastName ||
      (initialValue?.phone ?? '') !== (currentValue.phone ?? '') ||
      initialValue?.language !== currentValue.language
    );
  }
}
